import React from "react";

import { cx } from "~/tools/class-variance";

export const WelcomeContainer: React.FC<React.ComponentProps<"div">> = ({ className, ...props }) => (
	<div {...props} className={cx("mx-auto max-w-7xl px-5", className)} />
);

export const NBSP = "\u00a0";
